import { TAB_TYPE } from '../constants';

export const getTabUrl = (tabName, params) => {
  switch (tabName) {
    case TAB_TYPE.POINTS:
      return 'member_points';
    case TAB_TYPE.USER_CREADITS:
      return 'user_credits';
    case TAB_TYPE.PROFILE:
      return `/users/${params}/edit`;
  }
};
